<div class="grid h-full place-items-center px-6 py-4">
  <div class="flex flex-col items-center justify-center gap-y-6 text-center">
    <h1 class="text-5xl font-semibold tracking-tight text-balance text-gray-900">{{ title() }}</h1>
    <p class="text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">{{ subtitle() }}</p>
    @if(!hideButton()) {
      <div class="flex items-center justify-center gap-x-6">
        <a matButton="filled" ariaLabel="Ir a la página de inicio" (click)="buttonClicked.emit()" (keydown.enter)="buttonClicked.emit()" (keydown.space)="buttonClicked.emit()" tabindex="0">{{ buttonText() }}</a>
      </div>
    }
  </div>
</div>
